import { PropsWithChildren, useMemo } from 'react';

import { OrderContext, OrderContextProps } from './OrderContext';

export interface OrderProviderProps
  extends Pick<
    OrderContextProps,
    | 'schemas'
    | 'orderType'
    | 'directories'
    | 'brokerTimezoneOffset'
    | 'order'
    | 'disabledDates'
    | 'minEndDate'
    | 'isDisabledDirectoryFreeSolo'
  > {}

export const OrderProvider = ({
  children,
  schemas,
  orderType,
  directories,
  brokerTimezoneOffset,
  order,
  disabledDates,
  minEndDate,
  isDisabledDirectoryFreeSolo,
}: OrderProviderProps & PropsWithChildren) => {
  const value = useMemo(
    () => ({
      schemas,
      isDisabledDirectoryFreeSolo,
      orderType,
      directories,
      brokerTimezoneOffset,
      order,
      disabledDates,
      minEndDate,
    }),
    [
      schemas,
      isDisabledDirectoryFreeSolo,
      orderType,
      directories,
      brokerTimezoneOffset,
      order,
      disabledDates,
      minEndDate,
    ]
  );

  return (
    <OrderContext.Provider value={value}>{children}</OrderContext.Provider>
  );
};
